import { useEffect } from "react";
import { Loader2 } from "lucide-react";

const AuthHandoff = () => {
  useEffect(() => {
    const hash = window.location.hash || "";
    const target = hash ? `/${hash}` : "/";
    window.location.replace(target);
  }, []);

  return (
    <div className="flex h-screen items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-3">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <p className="text-sm text-muted-foreground">Finishing sign-in…</p>
      </div>
    </div>
  );
};

export default AuthHandoff;
